import React from "react"
import { bg1 } from "./icon_bg1"
import { bg2 } from "./icon_bg2"
import { iconBottomLogo } from "./icon_bottom_logo"

export const icons = {
  arrow: {
    viewBox: "0 0 8.41 17.96",
    customCode: (
      <path
        fill="currentColor"
        d="M1.5,18A1.5,1.5,0,0,1,.42,15.42l4.11-4.27a3.12,3.12,0,0,0,0-4.34L.42,2.54A1.5,1.5,0,1,1,2.58.46L6.69,4.73a6.12,6.12,0,0,1,0,8.5L2.58,17.5A1.52,1.52,0,0,1,1.5,18Z"
      />
    ),
  },

  burger: {
    viewBox: "0 0 33.53 24.11",
    customCode: (
      <g fill="currentColor">
        <path d="M31.53,4H2A2,2,0,0,1,2,0H31.53a2,2,0,0,1,0,4Z" />
        <path d="M31.53,14.06H2a2,2,0,0,1,0-4H31.53a2,2,0,0,1,0,4Z" />
        <path d="M31.53,24.11H2a2,2,0,0,1,0-4H31.53a2,2,0,0,1,0,4Z" />
      </g>
    ),
  },

  close: {
    viewBox: "0 0 24.98 24.98",
    customCode: (
      <g fill="currentColor">
        <path d="M23,25a2,2,0,0,1-1.41-.58L11.08,13.91a2,2,0,0,1,2.83-2.83L24.4,21.57A2,2,0,0,1,23,25Z" />
        <path d="M7.1,9.1a2,2,0,0,1-1.41-.58L.59,3.41A2,2,0,0,1,.59.59a2,2,0,0,1,2.82,0l5.11,5.1A2,2,0,0,1,7.1,9.1Z" />
        <path d="M2,25A2,2,0,0,1,.59,21.57l21-21A2,2,0,0,1,24.4,3.41l-21,21A2,2,0,0,1,2,25Z" />
      </g>
    ),
  },

  logo: {
    viewBox: "0 0 165.81 25.11",
    customCode: (
      <g fill="currentColor">
        <path d="M137.8,25.11H123.94a7.52,7.52,0,1,1,0-15h8.62a2.56,2.56,0,1,0,0-5.11H120.64a2.48,2.48,0,0,1,0-5h11.92a7.52,7.52,0,1,1,0,15h-8.62a2.56,2.56,0,0,0,0,5.12H137.8a2.48,2.48,0,0,1,0,5Z" />
        <path d="M163.33,25.11H149.47a7.52,7.52,0,0,1,0-15h8.62a2.56,2.56,0,1,0,0-5.11H146.16a2.48,2.48,0,1,1,0-5h11.93a7.52,7.52,0,1,1,0,15h-8.62a2.56,2.56,0,0,0,0,5.12h13.86a2.48,2.48,0,0,1,0,5Z" />
        <path d="M26.24,5.65H2.48a2.48,2.48,0,0,1,0-5H26.24a2.48,2.48,0,1,1,0,5Z" />
        <path d="M14.36,24.38a2.48,2.48,0,0,1-2.48-2.48V7.7a7,7,0,0,1,7-7h7.36a2.48,2.48,0,1,1,0,5H18.88a2.05,2.05,0,0,0-2,2.05V21.9A2.48,2.48,0,0,1,14.36,24.38Z" />
        <path d="M45.84,24.38H34.11a2.48,2.48,0,1,1,0-5H45.84a6.89,6.89,0,0,0,0-13.77H36.59v6.92a2.48,2.48,0,0,1-5,0V3.17A2.48,2.48,0,0,1,34.11.69H45.84a11.85,11.85,0,0,1,0,23.69Z" />
        <path d="M64.28,24.41a2.48,2.48,0,0,1-2.48-2.48V3.21a2.48,2.48,0,0,1,5,0V21.93A2.48,2.48,0,0,1,64.28,24.41Z" />
        <path d="M83,24.41a2.48,2.48,0,0,1-2.48-2.48V3.21a2.48,2.48,0,1,1,5,0V21.93A2.48,2.48,0,0,1,83,24.41Z" />
        <path d="M83,24.41a2.48,2.48,0,0,1-1.76-4.23L100,1.45A2.48,2.48,0,1,1,103.48,5L84.76,23.69A2.49,2.49,0,0,1,83,24.41Z" />
        <path d="M64.28,24.41a2.48,2.48,0,0,1-1.75-4.23L81.25,1.45A2.48,2.48,0,0,1,84.76,5L66,23.69A2.46,2.46,0,0,1,64.28,24.41Z" />
      </g>
    ),
  },

  "bottom-logo": iconBottomLogo,
  bg1,
  bg2,
}
